export default __webpack_public_path__ + "static/1148-a5f004e7cd6256b28e57d062f63c304c.gif";